import { TextField, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// import { useSelector, useDispatch } from 'react-redux';
import { getCustomers, getOrganizationData, getGroupUsers, updateUser, getDepartment } from './../../../services/api';
// import { setCustomers, setGroupUsers, setOrganization, setUsers } from '../../../store/dataFromBESlice';
// import { useParams, useHistory, useLocation } from 'react-router-dom';
// import { useSnackbar } from 'notistack';
// import ChangePassword from './changePassword.component';
import { FilterBy } from '../../commons/filter.component';
import ButtonWithAPICallComponent from '../../commons/ButtonWithAPICall.component';

const EditUser = ({ initialData, onClose, onSaveResponse }) => {
    const [t] = useTranslation()
    const [inputData, setInputData] = useState({
        id: '',
        name: '',
        email: '',
        organization: null,
        usergroup: null,
        password: null,
        department: null
    })
    const handleSave = () => {
        return updateUser(inputData.id, {
            ...inputData,
            customer_id: inputData.customer?.id,
            organization_id: inputData.organization?.id || null,
            usergroup_id: inputData.usergroup?.id || null,
            password: inputData.password || null,
            department_id: inputData.department?.id || null
        })
    }

    // effect
    useEffect(() => {
        if (!initialData) return
        setInputData({
            ...initialData,
            organization: null,
            usergroup: null,
            customer: null
        })
    }, [initialData])

    return (
        <Dialog open={Boolean(initialData)} maxWidth={false} onClose={onClose}>
            <DialogTitle align='center'>
                {t('Chỉnh sửa thông tin người dùng')}
            </DialogTitle>
            <DialogContent align='center' style={{ paddingTop: 10 }}>
                <TextField
                    label={t("Tên người dùng")}
                    style={{ margin: '5px 0' }}
                    onChange={e => setInputData(prev => ({ ...prev, name: e.target.value }))}
                    value={inputData.name}
                    fullWidth
                />
                <TextField
                    label='Email'
                    style={{ margin: '5px 0' }}
                    onChange={e => setInputData(prev => ({ ...prev, email: e.target.value }))}
                    value={inputData.email}
                    fullWidth
                />
                {
                    inputData.customer_id &&
                    <FilterBy
                        label={t('Khách hàng')}
                        getDataFunc={() => getCustomers({ status: 1 })}
                        setDefaultFunc={option => setInputData(prev => ({ ...prev, customer: option.find(item => item.id === initialData.customer_id) || null }))}
                        triggerSetDefaultFunc={initialData}
                        setDefaultDependencies={[initialData]}
                        value={inputData.customer}
                        onChange={(e, newValue) => setInputData(prev => ({ ...prev, customer: newValue }))}
                        style={{ margin: '5px 0 10px' }}
                    />
                }
                {
                    !inputData.customer_id &&
                    <>
                        <FilterBy
                            label={t('Tổ chức')}
                            getDataFunc={() => getOrganizationData({ params: { status: 1 } })}
                            setDefaultFunc={option => setInputData(prev => ({ ...prev, organization: option.find(item => item.id === initialData.organization_id) || null }))}
                            triggerSetDefaultFunc={initialData}
                            value={inputData.organization}
                            onChange={(e, newValue) => setInputData(prev => ({ ...prev, organization: newValue, department: null }))}
                            style={{ margin: '5px 0 10px' }}
                        />
                        <FilterBy
                            disabled={!inputData.organization && !inputData.customer_id}
                            getDataFunc={() => getDepartment({ params: { status: 1 } })}
                            setDefaultFunc={option => setInputData(prev => ({ ...prev, department: option.find(item => item.id === initialData.department_id) || null }))}
                            triggerSetDefaultFunc={initialData}
                            label={t('Phòng ban')}
                            value={inputData.department}
                            onChange={(e, newValue) => setInputData(prev => ({ ...prev, department: newValue }))}
                            style={{ margin: '5px 0 5px 0' }}
                            filter={option => option.organization_id === inputData.organization?.id}
                        />
                    </>
                }
                <FilterBy
                    label={t('Nhóm người dùng')}
                    getDataFunc={() => getGroupUsers({ status: 1 })}
                    setDefaultFunc={option => setInputData(prev => ({ ...prev, usergroup: option.find(item => item.id === initialData.usergroup_id) || null }))}
                    triggerSetDefaultFunc={initialData}
                    value={inputData.usergroup}
                    onChange={(e, newValue) => setInputData(prev => ({ ...prev, usergroup: newValue }))}
                    style={{ margin: '10px 0 5px' }}
                />
                <TextField
                    type='password'
                    label={t('Mật khẩu mới')}
                    style={{ margin: '5px 0' }}
                    value={inputData.password || ''}
                    onChange={e => setInputData(prev => ({ ...prev, password: e.target.value }))}
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('Hủy')}</Button>
                <ButtonWithAPICallComponent variant='contained' api={handleSave} response={onSaveResponse}>
                    {t('Lưu')}
                </ButtonWithAPICallComponent>
            </DialogActions>
        </Dialog>
    )
}

export default EditUser
